export default __webpack_public_path__ + "static/media/yeezy.b05f135e.jpg";